exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Logistics__root___2TYBh {\n  max-width: 920px;\n  padding: 0 16px;\n}\n\n.Logistics__map___1MFZg {\n  border: none;\n  height: 480px;\n  width: 100%;\n}\n\n.Logistics__header___2QrxE:not(:first-child) {\n  margin-top: 24px;\n}\n\n.Logistics__header___2QrxE {\n  margin-bottom: 8px;\n}\n\n.Logistics__taxiText___1_A2H {\n  margin-bottom: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"root": "Logistics__root___2TYBh",
	"map": "Logistics__map___1MFZg",
	"header": "Logistics__header___2QrxE",
	"taxiText": "Logistics__taxiText___1_A2H"
};